import React from 'react';
import { Step as EdsStep } from '@hedtech/react-design-system/core/es/StepProgress';
const Step = (props) => (React.createElement(EdsStep, Object.assign({}, props)));
export default Step;
